import { connect } from 'react-redux';
import MenuButton from './component';
import {
    logout
} from './actions';

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.loginReducer
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        logout: () => dispatch(logout())
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuButton);